import { unitTypes } from "keys"

class Class {
    constructor(testTaker) {
        const { name, grade, group, affiliation, school_year } = testTaker
        this.name = name

        if (group)
            this.group = group.id
        if (grade)
            this.grade = grade.id || grade
        if (affiliation)
            this.affiliation = affiliation.id || affiliation
        if (school_year)
            this.school_year = school_year
    }
}

export default Class